import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};
createReduxPromiseActionType(actionTypes, "TEMPLATE_MODULES_FETCH");
createReduxPromiseActionType(actionTypes, "TEMPLATE_MODULE_CREATE");
createReduxPromiseActionType(actionTypes, "TEMPLATE_MODULE_UPDATE");
createReduxPromiseActionType(actionTypes, "MODULE_TOPICS_FETCH");

export default actionTypes;
